module.exports = __webpack_public_path__ + "media/images/tailings_pond-c969e154ae336114ed9f99a551f0a33e.png";